const localeSettingsMap: Partial<Record<server.dto.LCID, server.dto.CultureDefinition>> = {
  "english_US": {
    uiLanguage: "en",
    uiLocale: "en-US"
  },
  "english_GB": {
    uiLanguage: "en",
    uiLocale: "en-GB"
  },
  "english_IE": {
    uiLanguage: "en",
    uiLocale: "en-IE"
  },
  "dutch_NL": {
    uiLanguage: "nl",
    uiLocale: "nl-NL"
  },
  "dutch_BE": {
    uiLanguage: "nl",
    uiLocale: "nl-BE"
  },
  "german_DE": {
    uiLanguage: "de",
    uiLocale: "de-DE"
  },
  "spanish": {
    uiLanguage: "es",
    uiLocale: "es-ES"
  },
  "portuguese_BR": {
    uiLanguage: "pt",
    uiLocale: "pt-BR"
  },
  "portuguese_PT": {
    uiLanguage: "pt",
    uiLocale: "pt-PT"
  },
  "italian": {
    uiLanguage: "it",
    uiLocale: "it-IT"
  }
};

const viewModel = (window as any).viewModel as any;

if (typeof viewModel.webformId === "number" && typeof viewModel.culture === "string") {
  serverReference.culture = localeSettingsMap[viewModel.culture] ?? localeSettingsMap["english_GB"];
}